import * as api from 'common/api'

export let list = () => api.get('s3/plan/list')

export let admin_list = () => api.get('s3/manager/plan/list')

export let get = params => api.get('s3/plan/edit', params)

export let edit = data => api.postFile('s3/plan/edit', data)

export let remove = params => api.post('s3/plan/delete', params)

export let batch_download = params => api.get('s3/plan/download', params)



// WEBPACK FOOTER //
// ./src/api/plan.js